<template>
    <div>
        <a class="btn-annotation btn-play-karaoke"
           href="#"
           :style="data.styleRect"
           @click.prevent="playSinglePageKaraoke"
        >
            <img :src="`${bookInfoState.publicPath}/${props.annot.iconSrc}`"
                 v-if="props.annot.iconSrc"
            >
        </a>
    </div>
</template>

<script>
    import {ref, reactive, onMounted, onUpdated, watchEffect, watch, computed, nextTick}  from "vue";
    import {useParser} from "@/modules/reader/annotations/parser";
    import {useBookInfo} from "@/modules/reader/book/bookinfo";
    import {usePageResize} from "@/modules/reader/book/pageResize";
    import {useAnnotationHelper} from "@/modules/reader/annotations/annotationHelper";
    import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
    import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
    import cssvar from '@/scss/_variables.scss';
    //import {replaceAudioPathForStagingServer} from  "@/modules/utils/pathUtils";

    const colorRect = cssvar.colorRect;
    const {getResizedAnnotationPos, styleAnnotationBtn} = useAnnotationHelper();

    export default {

        props: {
          annot:Object,
          sharedMeta:Object,
          pagenum:Number
        },
        setup(props, context) {

            const { parserState, readData} = useParser();
            const { bookInfoState} = useBookInfo();
            const { pageResizeState} = usePageResize();
            const { karaokeState, setCurrentAudioSrc, stopAnimation, MODE_WHOLE_PAGE, MODE_MULTIPLE_WHOLE_PAGE, playParagraph} = useKaraokeControl();

            const data = reactive({
                styleRect:computed(()=>{
                    let domPos = props.annot.domPos;
                    return {
                        ...getResizedAnnotationPos(domPos),
                        ...styleAnnotationBtn()
                    }
                }),
                wordAudioData:computed(()=>{
                    return  props.sharedMeta[karaokeState.activeGrouptag]["wordAudioData"][bookInfoState.activeSpeech];
                })
            });

            const playSinglePageKaraoke = ()=> {
                //Note that stopAnimation will reset karaoke state, playPageKaraoke will be called in multiPage mode also (by updating reactive state and called in watchEffect)
                //since we shouldn't reset the multiple page karaoke state, so call stopAnimation here instead of inside playPageKaraoke()
                usePlayBlockControl().reset();
                stopAnimation();
                useKaraokeControl().reset();
                karaokeState.playMode = MODE_WHOLE_PAGE;
                playPageKaraoke();
            }

            const playMultiplePageKaraoke = ()=> {
                karaokeState.playMode = MODE_MULTIPLE_WHOLE_PAGE;
                playPageKaraoke();
            }

            const playPageKaraoke = ()=> {

                karaokeState.wholePageData = [];
                karaokeState.currentAudioId = props.annot.audioIds[0];

                for (let [key, meta] of Object.entries(props.sharedMeta)) {
                    karaokeState.activeGrouptag = meta.grouptag;
                    karaokeState.activeAudioSrc = meta.audioSrc;

                    karaokeState.wholePageData.push({
                        grouptag: meta.grouptag,
                        audioSrc: meta.audioSrc,
                        audioId: meta.audioId,
                        wordAudioData:props.sharedMeta[ meta.grouptag]["wordAudioData"][bookInfoState.activeSpeech]
                    });
                }

                karaokeState.currentAudioId = karaokeState.wholePageData[0].audioId;
                karaokeState.activeGrouptag = karaokeState.wholePageData[0].grouptag
                karaokeState.activeAudioSrc = setCurrentAudioSrc(karaokeState.wholePageData[0].audioSrc);
                //if served on staging (.23), update url to make 206 response available...
                //karaokeState.activeAudioSrc  = replaceAudioPathForStagingServer(karaokeState.activeAudioSrc);
                karaokeState.activeAudioSrc  = karaokeState.activeAudioSrc;
                karaokeState.activePageNum = props.pagenum;

                console.log( karaokeState.wholePageData)
                //nextTick is required here since we need wait for the audio player to be available to play after currentAudioId is set
                nextTick(()=>{
                    playParagraph( data.wordAudioData);
                })

            };

            onMounted(() => {

                console.log("@playpagekaraokebtn mounted")
            });

            watchEffect(()=>{

                if (karaokeState.multiWholePageStatus.multiPageTargetBtnId === props.annot.id &&
                    karaokeState.multiWholePageStatus.multiPageTargetPageNum === props.pagenum) {
                    console.log("multi page karaoke target retrieved! @PlayPageKaraokeBtn.vue");
                    playMultiplePageKaraoke();
                }

            })

            return {
                props,
                data,
                pageResizeState,
                bookInfoState,
                parserState,
                karaokeState,
                playSinglePageKaraoke,
                playParagraph,
                stopAnimation,
                setCurrentAudioSrc,
                getResizedAnnotationPos
            }

        }
    }

 </script>


<style scoped lang="scss">


</style>